module.exports = __webpack_public_path__ + "static/media/chrome.411304e3.svg";